import {
    Button,
    Flex,
    Tab,
    TabGroup,
    TabList,
    Text,
    TextInput,
} from '@tremor/react'
import { useEffect, useState } from 'react'
import { useApiV1SmeCreate } from '../../api/api.gen'
import { toErrorString } from '../../utilities/error'

interface PageTexts {
    title: string
    companyName: string
    contactName: string
    contactPhone: string
    contactEmail: string
    SMENumber: string
    CRNumber: string
    FieldOfWork: string
    done: string
    backButton: string
    submitButton: string
    required: string
}

const arText: PageTexts = {
    title: `لمدة شهرين، تقدم وتد للتكنلوجيا خصمًا بنسبة 50% للشركات الحاملة لبطاقة ريادة.
سجل رقم مؤسستك الصغيرة أو المتوسطة وبياناتك للاستفادة من خصم إضافي بنسبة 50% على خدمات وتك للتكنلوجيا`,
    companyName: 'اسم الشركة',
    contactName: 'اسم جهة الاتصال',
    contactPhone: 'رقم الهاتف للتواصل',
    contactEmail: 'البريد الإلكتروني للتواصل',
    SMENumber: 'رقم الشركات المتوسطة والصغيرة',
    CRNumber: 'رقم السجل التجاري',
    FieldOfWork: 'مجال العمل',
    done: `نشكرك على وقتك ، 
فريق العمل سوف يراجع ملف الشركة وسيتم الرد عليك في غضون ٦ ساعات`,
    backButton: 'خلف',
    submitButton: 'يُقدِّم',
    required: 'مطلوب',
}
const enText: PageTexts = {
    title: `for a 2 month period Watad Tech is offering 50% discount for Companies Holding the riyada card.
Register your Company SME number and credentials to enjoy an extra 50% discount on Watad Tech`,
    companyName: 'Company Name',
    contactName: 'Contact Name',
    contactPhone: 'Contact Phone',
    contactEmail: 'Contact Email',
    SMENumber: 'SME Number',
    CRNumber: 'CR Number',
    FieldOfWork: 'Field of work',
    done: `Thank you for taking the time.
Our team will review your company and get back to you within 6 hours`,
    backButton: 'Back',
    submitButton: 'Submit',
    required: 'Required',
}

export function SMEPage() {
    const [lang, setLang] = useState('ar')
    const [texts, setTexts] = useState(arText)
    const [company, setCompany] = useState('')
    const [crNumber, setCrNumber] = useState('')
    const [fieldOfWork, setFieldOfWork] = useState('')
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [smeNumber, setSmeNumber] = useState('')
    const [showSuccess, setShowSuccess] = useState(false)
    const [tried, setTried] = useState(false)

    const { isExecuted, isLoading, sendNowWithParams, error } =
        useApiV1SmeCreate({}, {}, false)

    useEffect(() => {
        if (isExecuted && !isLoading) {
            setShowSuccess(true)
        }
    }, [isLoading])

    const isEmpty = (f: string) => {
        return f.trim().length === 0
    }

    if (showSuccess) {
        return (
            <div dir={lang === 'ar' ? 'rtl' : 'ltr'}>
                <Flex
                    className="w-full h-screen bg-gray-100 space-y-4"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Flex
                        flexDirection="col"
                        alignItems="start"
                        justifyContent="start"
                        className="w-fit bg-gray-100 space-y-1"
                    >
                        <Text
                            className={`text-black text-xl ${
                                lang === 'ar' ? 'text-right' : 'text-left'
                            }`}
                        >
                            {texts.done}
                        </Text>
                        <Flex
                            flexDirection="row"
                            className="w-full pt-6"
                            justifyContent="end"
                        >
                            <a href="https://watadtech.om">
                                <Button variant="secondary" color="teal">
                                    {texts.backButton}
                                </Button>
                            </a>
                        </Flex>
                    </Flex>
                </Flex>
            </div>
        )
    }

    return (
        <Flex
            className="w-full h-screen bg-gray-100"
            alignItems="center"
            justifyContent="center"
        >
            <Flex
                flexDirection="col"
                alignItems={lang === 'ar' ? 'end' : 'start'}
                justifyContent={lang === 'ar' ? 'end' : 'start'}
                className="w-1/2 bg-gray-100 space-y-1"
            >
                <Flex
                    flexDirection="row"
                    justifyContent="end"
                    alignItems="end"
                    className="w-full"
                >
                    <TabGroup
                        className="w-fit"
                        onIndexChange={(idx) => {
                            if (idx === 0) {
                                setLang('ar')
                                setTexts(arText)
                            } else {
                                setLang('en')
                                setTexts(enText)
                            }
                        }}
                    >
                        <TabList variant="solid">
                            <Tab>عربی</Tab>
                            <Tab>English</Tab>
                        </TabList>
                    </TabGroup>
                </Flex>
                <Text
                    className={`text-black text-xl pb-6 ${
                        lang === 'ar' ? 'text-right' : 'text-left'
                    }`}
                >
                    {texts.title}
                </Text>
                <Text className="text-black">{texts.companyName}:</Text>
                <TextInput
                    value={company}
                    onValueChange={setCompany}
                    error={company.length === 0 && tried}
                    errorMessage={texts.required}
                />
                <Text className="text-black">{texts.contactName}:</Text>
                <TextInput
                    value={name}
                    onValueChange={setName}
                    error={name.length === 0 && tried}
                    errorMessage={texts.required}
                />
                <Text className="text-black pt-4">{texts.contactPhone}:</Text>
                <TextInput
                    value={phone}
                    onValueChange={setPhone}
                    error={phone.length === 0 && tried}
                    errorMessage={texts.required}
                />
                <Text className="text-black pt-4">{texts.contactEmail}:</Text>
                <TextInput
                    value={email}
                    onValueChange={setEmail}
                    error={email.length === 0 && tried}
                    errorMessage={texts.required}
                />
                <Text className="text-black pt-4">{texts.SMENumber}:</Text>
                <TextInput
                    value={smeNumber}
                    onValueChange={setSmeNumber}
                    error={smeNumber.length === 0 && tried}
                    errorMessage={texts.required}
                />
                <Text className="text-black pt-4">{texts.CRNumber}:</Text>
                <TextInput
                    value={crNumber}
                    onValueChange={setCrNumber}
                    error={crNumber.length === 0 && tried}
                    errorMessage={texts.required}
                />
                <Text className="text-black pt-4">{texts.FieldOfWork}:</Text>
                <TextInput value={fieldOfWork} onValueChange={setFieldOfWork} />
                <Text className="text-red-500">{toErrorString(error)}</Text>
                <Flex
                    flexDirection="row"
                    justifyContent="end"
                    className="w-full pt-4"
                >
                    <Button
                        loading={isExecuted && isLoading}
                        disabled={isExecuted && isLoading}
                        variant="secondary"
                        color="teal"
                        onClick={() => {
                            setTried(true)
                            if (
                                isEmpty(company) ||
                                isEmpty(name) ||
                                isEmpty(phone) ||
                                isEmpty(email) ||
                                isEmpty(smeNumber) ||
                                isEmpty(crNumber)
                            ) {
                                return
                            }

                            sendNowWithParams(
                                {
                                    company,
                                    name,
                                    phone,
                                    email,
                                    smeNumber,
                                    crNumber,
                                    fieldOfWork,
                                },
                                {}
                            )
                        }}
                    >
                        {texts.submitButton}
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    )
}
